import { Injectable } from '@angular/core';
import { ProposalBillingItem, ProposalReceipt } from 'app/entities';
import { ApiService } from 'app/services/api.service';
import { environment } from 'environments/environment';
import { map } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class ProposalReceiptService extends ApiService {
    findAll(proposalId: number) {
        return this.httpService.get(`/v1/clients/proposals/${proposalId}/receipts`)
            .pipe(
                map(res => ({
                    data: ProposalReceipt.parse(res.data || []) as ProposalReceipt[],
                    summary: this.parseSummary(res.summary)
                }))
            );
    }

    create(proposalId: number, data: any) {
        const formData = this.formDataFromObject(data);

        return this.httpService.post(`/v1/clients/proposals/${proposalId}/receipts`, formData)
            .pipe(map(res => ProposalReceipt.parse(res.data) as ProposalReceipt));
    }

    update(proposalId: number, receiptId: number, data: any) {
        const formData = this.formDataFromObject(data);
        formData.append('_method', 'PUT');

        return this.httpService.post(`/v1/clients/proposals/${proposalId}/receipts/${receiptId}`, formData)
            .pipe(map(res => ProposalReceipt.parse(res.data) as ProposalReceipt));
    }

    bulkReceipts(proposalId: number, issueDate?: string) {
        const body = issueDate ? { issue_date: issueDate } : {};
        return this.httpService.post(`/v1/clients/proposals/${proposalId}/receipts/bulk`, body)
            .pipe(map(res => ({
                message: res.message as string,
                data: ProposalReceipt.parse(res.data || []) as ProposalReceipt[],
            })));
    }

    delete(proposalId: number, receiptId: number) {
        return this.httpService.delete(`/v1/clients/proposals/${proposalId}/receipts/${receiptId}`);
    }

    pdf(proposalId: number, receiptId: number) {
        return this.httpService.getBlob(`/v1/clients/proposals/${proposalId}/receipts/${receiptId}/pdf`);
    }

    pdfUrl(receipt: ProposalReceipt): string | null {
        if (!receipt.token) {
            return null;
        }

        const timestamp = receipt.updatedAt ? receipt.updatedAt.getTime() : Date.now();
        return `${environment.baseUrlHotsite}/recibo/${receipt.token}.pdf?v=${timestamp}`;
    }

    private parseSummary(summary: any) {
        if (!summary) {
            return {
                totalReceipts: 0,
                totalReceiptAmount: 0,
                totalProposalAmount: 0,
                remainingAmount: 0,
                exceededAmount: 0,
                paidItemsWithoutReceipts: [],
            };
        }

        return {
            totalReceipts: Number(summary.total_receipts || 0),
            totalReceiptAmount: Number(summary.total_receipt_amount || 0),
            totalProposalAmount: Number(summary.total_proposal_amount || 0),
            remainingAmount: Number(summary.remaining_amount || 0),
            exceededAmount: Number(summary.exceeded_amount || 0),
            paidItemsWithoutReceipts: ProposalBillingItem.parse(summary.paid_items_without_receipts || []) as ProposalBillingItem[],
        };
    }
}
